<template>
  <section class="default" :class="classNames">
    <div class="title-wrapper" :style="styles">
      <div class="title">
        <VUnderline
          v-show="useUnderline"
          class="underline"
          :width="underlineWidth"
          :height="10"
          :type="imageType"
        />
        <VSpan
          class="title-text"
          :text="title"
          :size="size"
          :weight="TextWeight.bold"
          :color="TextColor.darkGray"
          :spacing="-0.38"
        />
      </div>
    </div>
    <slot></slot>
  </section>
</template>

<script>
import VSpan, { TextColor, TextWeight } from '@/presentationals/v2/components/layouts/atoms/VSpan'
import VUnderline from '@/presentationals/v2/components/layouts/atoms/VUnderline'

export const ColorType = Object.freeze({
  none: 'transparent',
  brand: 'brand-background',
  gray: 'gray-background',
  white: 'white-background'
})

export default {
  name: 'VSection',
  props: {
    title: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 16
    },
    color: {
      type: String,
      default: ColorType.white
    },
    underlineWidth: {
      type: Number
    },
    useUnderline: {
      type: Boolean,
      default: true
    },
    imageType: {
      type: Number,
      default: 0
    },
    margin: {
      type: Array,
      default: () => []
    },
    padding: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    calcPosition(array) {
      return array.reduce((iter, curr, idx) => {
        if (idx === 0) {
          iter = `${curr}px`
        } else {
          iter += ` ${curr}px`
        }

        return iter
      }, '')
    }
  },
  components: {
    VSpan,
    VUnderline
  },
  computed: {
    classNames() {
      return [this.color]
    },
    styles() {
      const obj = {}
      this.margin.length > 0 && (obj['margin'] = this.calcPosition(this.margin))
      this.padding.length > 0 && (obj['padding'] = this.calcPosition(this.padding))

      return obj
    }
  },
  data() {
    return {
      TextWeight,
      TextColor
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.default {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  .title-wrapper {
    .title {
      position: relative;

      .title-text {
        position: relative;
        z-index: 1;
      }

      .underline {
        position: absolute;
        left: -2px;
        bottom: 2px;
        z-index: 0;
      }
    }
  }
}

.transparent {
  background-color: transparent;
}

.brand-background {
  background-color: $brand;
}

.gray-background {
  background-color: $background-gray;
}

.white-background {
  background-color: $background-white;
}
</style>